export class RespNotesModel {
    respNoteID: number
    sequence_no: number
    pet_no: number
    note_date: string | null
    note_text: string | null
    note_type: string | null
    note_value: string | null

    constructor(
        respNoteID: number,
        sequence_no: number,
        pet_no: number,
        note_date: string | null,
        note_text: string | null,
        note_type: string | null,
        note_value: string | null
    ) {
        this.respNoteID = respNoteID
        this.sequence_no = sequence_no
        this.pet_no = pet_no
        this.note_date = note_date
        this.note_text = note_text
        this.note_type = note_type,
        this.note_value = note_value
    }
}
